<template>
  <div>
    <div class="dropdown-menu" :class="{show: $parent.openedDropdownMenu === 'admin'}">
      <h6 class="dropdown-header">{{ $t("UI_PYTHON_DATA_IMPORT_BUTTON") }}</h6>
      <!-- User is in Instance Edit Mode -->
      <button class="dropdown-item" v-if="$store.getters.instanceLoaded" @click="$snotify.error($t('UI_PYTHON_DATA_IMPORT_BUTTON_SELECTION_DISABLED'))">
        {{ $t("UI_PYTHON_DATA_IMPORT_BUTTON") }}
      </button>

      <!-- User has no open Instance -->
      <button class="dropdown-item" @click="$refs.dataImportModal.open()" v-else>
        {{ $t("UI_PYTHON_DATA_IMPORT_BUTTON") }}
      </button>
    </div>

    <!-- Data Importer Modal -->
    <sweet-modal :title="$t('UI_PYTHON_DATA_IMPORT_BUTTON')" ref="dataImportModal" v-on:open="modalOpenedEvent">
      <loading :active.sync="isLoading" :is-full-page="false"></loading>
      <div class="form-group">
        <label for="scriptTextarea">Script</label>
        <textarea id="scriptTextarea" rows="15" class="form-control" v-model="scriptCode"></textarea>
      </div>

      <div slot="button">
        <button class="btn btn-primary" @click="setScript">
          {{ $t("UI_MODAL_BUTTON_SAVE") }}
        </button>
        <button class="btn btn-secondary ml-1" @click="$refs.dataImportModal.close()">
          {{ $t("UI_MODAL_BUTTON_CLOSE") }}
        </button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { SweetModal } from 'sweet-modal-vue';
import { RepositoryFactory } from '../../../../repositories/RepositoryFactory';

const DataImporterRepository = RepositoryFactory.get('dataimporter');

export default {
  name: 'DataImporterNavbarAction',
  components: { SweetModal, Loading },
  data() {
    return {
      isLoading: true,
      scriptCode: '',
    };
  },
  methods: {
    async getScript() {
      this.isLoading = true;
      await DataImporterRepository.get().then((response) => {
        this.scriptCode = response.data.script;
      });
      this.isLoading = false;
    },

	    async setScript() {
		    this.isLoading = true;
		    await DataImporterRepository.set(this.scriptCode).then((response) => {
			    this.isLoading = false;
		    }).catch((error) => {
			    this.isLoading = false;
			    return Promise.reject(error);
      });
	    },

    async modalOpenedEvent(e) {
      await this.getScript();
    },
  },
};
</script>

<style scoped>

</style>
